export enum SineHeader {
  X_SINE_TEAM_ID = 'x-sine-team-id',
  X_SINE_DEVICE_ID = 'x-sine-device-id',
  X_SINE_VERSION = 'x-sine-version',
  AUTHORIZATION = 'Authorization',
  RQUID = 'rquid',
}
